import { MinMaxRange } from '../types/types';

export const EMPLOYEE_GROSS_HOUR_WAGE_RANGE: MinMaxRange = [8.3, 100];
export const MEAL_VOUCHERS_TOTAL_RANGE: MinMaxRange = [1.09, 10];
export const MEAL_VOUCHERS_EMPLOYEE_MIN: number = 1.09;

export const CONSTRUCTION_PC_CODE: string = '124';
export const PRIVATE_TRANSPORT_DEFAULT_PC_CODES: string[] = ['201', '302'];

export const DEFAULT_REVENUE_OFFICE_CODE: string = 'DPS100';
export const CONSTRUCTION_WAGE_REVENUE_OFFICE_CODE: string = 'DPS200';
